import React, { ReactElement } from 'react';

/** Hourglass-with-slash — matches Figma Active-Tickets expired status (node 2937:22138). */
export const ExpiredEventStatusIcon = (): ReactElement => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M9.32862 10L8.71614 9.38967H1.56655V8.4507H2.50883V7.04225C2.50883 6.56495 2.62073 6.11698 2.84452 5.69836C3.06832 5.27973 3.38045 4.94523 3.78092 4.69484C3.52964 4.53834 3.31567 4.35055 3.13899 4.13146C2.96231 3.91236 2.819 3.6698 2.70907 3.40376L0 0.704225L0.671378 0.0352113L10 9.33099L9.32862 10ZM6.77267 4.76526L6.06596 4.07277C6.41932 3.9241 6.70004 3.69327 6.90813 3.38028C7.11622 3.06729 7.22026 2.723 7.22026 2.34742V0.938967H3.45112V1.46714L1.9788 0H9.10483V0.938967H8.16254V2.34742C8.16254 2.8482 8.04083 3.31377 7.79741 3.74413C7.55399 4.17449 7.21241 4.51487 6.77267 4.76526ZM3.45112 8.4507H7.22026V7.89906L4.6172 5.30516C4.26384 5.45383 3.98115 5.68466 3.76914 5.99765C3.55713 6.31064 3.45112 6.65884 3.45112 7.04225V8.4507Z"
      fill="#1C1B1F"
    />
  </svg>
);
